import gql from 'graphql-tag';

const CONTENT_QUERY = gql`
  query getContent($slug: String!){
    getContent(slug: $slug) {
      title,
      body
    }
  }
`;

export default CONTENT_QUERY;



// WEBPACK FOOTER //
// ./src/graphql/queries/content.query.js